import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ActionModel } from '@models/admin/action.model';
import { TranslationPipe } from '@pipes/translation.pipe';
import { Params, RouterLink } from '@angular/router';
import { UiBtnComponent } from '@components/ui-components/ui-btn/ui-btn.component';
import { NgStyle } from '@angular/common';
import { ModalWindowService } from '@services/admin/modal-window.service';

@Component({
  selector: 'app-action-link',
  imports: [
    TranslationPipe,
    RouterLink,
    UiBtnComponent,
    NgStyle,
  ],
  templateUrl: './action-link.component.html',
  styleUrl: './action-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionLinkComponent {
  action = input<ActionModel>();
  fullWidth = input(false);

  protected readonly modalWindowService = inject(ModalWindowService);

  getLink(path: string): string {
    return path.split('?')[0];
  }

  getParams(path: string): Params {
    const params: Params = {};
    const queryParams = path.split('?')[1];
    if (queryParams) {
      const pairs = queryParams.split('&');
      for (const pair of pairs) {
        const [key, value] = pair.split('=');
        params[key] = value;
      }
    }
    return params;
  }
}
